{
  "nl": {
    "join": {
      "heading": "Welkom bij fobizz",
      "paragraph": "Activeer de toegang tot je licentiegroep. Je ontvangt de code van de contactpersoon bij jouw onderwijsinstelling.",
      "button": "Activeren",
      "back": "Naar startpagina",
      "autoSubmitting": "Licentie wordt geactiveerd …"
    }
  }
}
